angular.module('app')
    .directive('createReview', function () {
        return {
            templateUrl: 'components/directives/create_review/view.create_review.html',
            controller: 'CreateReviewController',
            controllerAs: 'createReview',
            bindToController: true,
            scope: {
                objectType: '<',
                objectSlug: '<'
            }
        }
    });
